
import Vue from 'vue'
import router from "./router"
import store from './vuex/store'
import { sync } from 'vuex-router-sync'
import app from './App'

sync(store, router)

var vm = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(app)
});



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/